import React, { type ReactNode } from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import { BLOC_LTR } from '../i18n/sens';
import { SensTexteLtr } from './Texte';

/**
 * Contenu en français gardé de GAUCHE À DROITE dans une interface arabe : CV et lettres générés,
 * leurs modèles et aperçus, texte des offres. Ils partent chez des recruteurs français, ou viennent
 * d'eux.
 *
 * Un conteneur plutôt qu'un simple `textAlign: 'left'` : sur Android, l'alignement d'un texte suit le
 * sens de son conteneur. Les textes enfants ajoutent `TEXTE_LTR` pour le sens bidirectionnel sur iOS.
 * Sur le web, `dir` fait de même pour react-native-web (voir RacineSens) ; le natif l'ignore.
 */
export function ContenuLtr({ children, style }: { children: ReactNode; style?: StyleProp<ViewStyle> }) {
  return (
    <View style={[BLOC_LTR, style]} {...({ dir: 'ltr' } as object)}>
      <SensTexteLtr>{children}</SensTexteLtr>
    </View>
  );
}
